module.exports = __webpack_public_path__ + "img/tacos.e725d48c.jpg";